import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoMyRewardsWidget" */ './CasinoMyRewardsWidget'),
  modules: ['./CasinoMyRewardsWidget'],
  loading: () => <div style={{ height: '218px' }} />
});

export default LoadableWidget;
